(function() {
    'use strict';

    angular
        .module('ccsTrApp')
        .controller('FixationDeleteController',FixationDeleteController);

    FixationDeleteController.$inject = ['$uibModalInstance', 'entity', 'Fixation'];

    function FixationDeleteController($uibModalInstance, entity, Fixation) {
        var vm = this;

        vm.fixation = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        
        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Fixation.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
